import React, { useEffect, useState, useCallback, useMemo } from "react";
import Heading from "../../components/commonComponents/Heading/Heading";
import styles from "../Inventory/Inventory.module.css";
import { RiFileExcel2Fill } from "react-icons/ri";
import { FaFilePdf } from "react-icons/fa";
import dayjs from "dayjs";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import customParseFormat from "dayjs/plugin/customParseFormat";
import AssignInventoryModal from "../Inventory/AssignInventoryModal";
import sampleExcelPath from "../DeviceManagement/UploadSims.xlsx";
import {
  generateCSV,
  generatePDF,
  handleCsvGeneration,
} from "../../utils/exportUtils";
import { Spinner } from "../../components/commonComponents/Spinner/Spinner";
import RangeActionFilter from "../Inventory/RangeActionFilter";
import CommonRangeFilter from "../../components/commonComponents/CommonRangeFilter";
import axios, { all } from "axios";
import {
  fetchInventoryData,
  fetchFilteredData,
  bulkUploadInventory,
  saveSimState,
  getOptions,
  GetExcel,
} from "./Utility";
import { useLocation } from "react-router-dom";
import UploadExcel from "./UploadExcel";
import { BASE_URL } from "../../config";
import SimManagementTable from "../../components/commonComponents/Table/SimManagementTable";
import { Button } from "@mui/material";
import { isSuperAdmin } from "../customerManagement/utility/authUtils";
import api from "../../components/commonComponents/axiosSetup";
import DeviceDetailsCardContent from "./DeviceDetailsCardContent";
import QuickIccidSearchModal from "./QuickIccidSearchModal";

dayjs.extend(customParseFormat);

const tableCss = {
  moduleHeight: "37.9rem",
  cellPadding: "12px 16px",
  tableWidth: "100%!important",
};

const buttonArray = [
  {
    name: "Filter",
    key: "filter",
    icon: null,
  },
  {
    name: null,
    key: "excel",
    icon: <RiFileExcel2Fill />,
  },
  {
    name: null,
    key: "pdf",
    icon: <FaFilePdf />,
  },
  {
    name: "Upload Sims",
    key: "uploadInventory",
    icon: null,
  },
];

const inventoryValidationRules = [
  {
    header: "ICCID",
    validate: (value, row, iccidSet) => {
      const normalizedValue = value ? value.toString().trim() : "";
      if (!normalizedValue) {
        return "ICCID is missing";
      } else if (iccidSet.has(normalizedValue)) {
        return "Duplicate ICCID";
      } else {
        iccidSet.add(normalizedValue);
        return null;
      }
    },
  },
];

const DeviceManagement = () => {
  const [generaldata, setGeneralData] = useState("General data");
  const handleClick = (tabname) => {
    setGeneralData(tabname);
  };
  const companyId = localStorage.getItem("userId");

  const [filters, setFilters] = useState({
    pageNo: 0,
    pageSize: 10,
    search: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [isbulk, setIsbulk] = useState(false);
  const [activeFilterPayload, setActiveFilterPayload] = useState({});
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [isFilterDataWithBulkUpload, setIsFilterDataWithBulkUpload] =
    useState(false);

  // UPDATED COLUMNS: Added Profile1 and Profile2 columns
  const superAdmin = isSuperAdmin();
  // console.log("superAdmin", superAdmin);
  const [columns, setColumns] = useState([
    {
      name: "Sr. No",
      selected: true,
      key: "serial",
      showExcel: true,
      showTable: false,
      showPDF: true,
      showcheck: true,
    },
    {
      name: "ICCID",
      selected: true,
      key: "iccid",
      showExcel: true,
      showTable: true,
      showPDF: true,
      clickable: false,
    },
    {
      name: "IMSI",
      selected: true,
      key: "imsi",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "Sim State",
      selected: true,
      key: "combinedSimState",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "Primary MSISDN",
      selected: true,
      key: "profile1_msisdn",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },

    {
      name: "Sim Profiles",
      selected: true,
      key: "profile",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "Primary Operator",
      selected: true,
      key: "profile1_vendor",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "Primary Profile State",
      selected: true,
      key: "profile1_simState",
      showExcel: superAdmin,
      showTable: superAdmin,
      showPDF: superAdmin,
    },

    {
      name: "Secondary Operator",
      selected: true,
      key: "profile2_vendor",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
        {
      name: "Secondary MSISDN",
      selected: true,
      key: "profile2_msisdn",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "Secondary Profile State",
      selected: true,
      key: "profile2_simState",
      showExcel: superAdmin,
      showTable: superAdmin,
      showPDF: superAdmin,
    },
    {
      name: "Teritary Operator",
      selected: true,
      key: "profile3_vendor",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "Teritary MSISDN",
      selected: true,
      key: "profile3_msisdn",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "Teritary Profile State",
      selected: true,
      key: "profile3_simState",
      showExcel: superAdmin,
      showTable: superAdmin,
      showPDF: superAdmin,
    },
    {
      name: "Allocated To",
      selected: true,
      key: "allocatedTo",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },

    {
      name: "Serial No",
      selected: true,
      key: "serialNo",
      showExcel: true,
      showTable: false,
      showPDF: true,
    },

    // {
    //   name: "Device Type",
    //   selected: true,
    //   key: "deviceType",
    //   showExcel: true,
    //   showTable: true,
    //   showPDF: true,
    // },
    // {
    //   name: "Device Model",
    //   selected: true,
    //   key: "deviceModel",
    //   showExcel: true,
    //   showTable: true,
    //   showPDF: true,
    // },
    // {
    //   name: "Sim Profile",
    //   selected: true,
    //   key: "profileType",
    //   showExcel: true,
    //   showTable: true,
    //   showPDF: true,
    // },

    {
      name: "Account",
      selected: true,
      key: "account",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "Sim Type",
      selected: true,
      key: "simType",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "Activation Date",
      selected: true,
      key: "activationDate",
      showExcel: true,
      showTable: false,
      showPDF: true,
    },
    // {
    //   name: "Device IMEI",
    //   selected: true,
    //   key: "deviceId",
    //   showExcel: true,
    //   showTable: true,
    //   showPDF: true,
    // },
    {
      name: "Valid Upto",
      selected: true,
      key: "validity",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "WhiteListing",
      selected: true,
      key: "dataWhitelistGroup",
      showExcel: false,
      showTable: false,
      showPDF: false,
    },
    {
      name: "SMSwhitelistGropupName",
      selected: true,
      key: "smsWhitelistGroup",
      showExcel: false,
      showTable: false,
      showPDF: false,
    },
    {
      name: "Request Id",
      selected: true,
      key: "masterRequestId",
      showExcel: false,
      showTable: true,
      showPDF: false,
    },
    // {
    //   name: "KYC Status",
    //   selected: true,
    //   key: "kycStatus",
    //   showExcel: false,
    //   showTable: true,
    //   showPDF: false,
    // },
    // {
    //   name: "KYC Master Request ID",
    //   selected: true,
    //   key: "kycMasterRequestId",
    //   showExcel: false,
    //   showTable: true,
    //   showPDF: false,
    // },
  ]);

  const [originalInventoryList, setOriginalInventoryList] = useState([]);
  const [duplicatedata, setDuplicatedata] = useState([]);
  const [commonFilteredData, setCommonFilteredData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [alertOpen, setAlertOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [statusColor, setStatusColor] = useState("");
  const [assignModal, setAssignModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [csvData, setCsvData] = useState(null);
  const [showCustomFilterCard, setShowCustomFilterCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const [globalCheckedItems, setGlobalCheckedItems] = useState(new Set());
  const [planDetails, setPlanDetails] = useState(null);
  const [KYCDetails, setKYCDetails] = useState(null);
  const [loadingPlan, setLoadingPlan] = useState(false);
  const [quickIccidModalOpen, setQuickIccidModalOpen] = useState(false);
  const location = useLocation();
  const {
    iccid,
    data,
    profileCombo,
    KycStatus,
    FilterTitle,
    simState,
    vendor,
    month,
    planId,
    profileCombos,
    profileSimState,
  } = location.state || {};
  const [options, setOptions] = useState([]);

  const mergeProfiles = (dataArray) => {
    if (!dataArray || dataArray.length === 0) return [];

    const relationMap = {};

    // Group by relationKey
    dataArray.forEach((item) => {
      const key = item.relationKey;

      if (!key) {
        // If no relationKey, treat as standalone
        const standaloneKey = `standalone_${item.iccid}`;
        relationMap[standaloneKey] = {
          primary: item,
          secondary: null,
          tertiary: null,
        };
        return;
      }

      if (!relationMap[key]) {
        relationMap[key] = {
          primary: null,
          secondary: null,
          tertiary: null,
        };
      }

      const profileType = item.profileType?.toLowerCase();

      if (profileType === "primary") {
        relationMap[key].primary = item;
      } else if (profileType === "secondary") {
        relationMap[key].secondary = item;
      } else if (profileType === "tertiary") {
        relationMap[key].tertiary = item;
      } 
    });

    // Merge data into single rows
    const merged = [];
    const incompletePairs = [];

    Object.entries(relationMap).forEach(([key, { primary, secondary, tertiary,  }]) => {
      if (!primary && !secondary) return;

      // Track incomplete pairs for debugging
      if ((primary && !secondary) || (!primary && secondary)) {
        incompletePairs.push(key);
      }

      // Use primary as base, or secondary if primary doesn't exist
      const baseItem = primary || secondary;

      // **NEW: Calculate combined SIM state logic**
      const getCombinedSimState = () => {
        const primaryState = primary?.simState?.toUpperCase();
        const secondaryState = secondary?.simState?.toUpperCase();

        // If either is ACTIVE, return ACTIVE
        if (primaryState === "ACTIVE" || secondaryState === "ACTIVE") {
          return "ACTIVE";
        }

        // If both are Available, return Available
        if (primaryState === "AVAILABLE" && secondaryState === "AVAILABLE") {
          return "Available";
        }

        // Otherwise, return whichever state exists (prioritize primary)
        return primaryState || secondaryState || "-";
      };

      const mergedItem = {
        ...baseItem,
        // Profile 1 (Primary) data - use primary data if exists
        profile1_msisdn: primary?.msisdn || "-",
        profile1_simState: primary?.simState || "-",
        profile1_vendor: primary?.vendor || "-",
        profile1_imsi: primary?.imsi || "-",

        // Profile 2 (Secondary) data - use secondary data if exists

        profile2_msisdn: secondary?.msisdn || "-",
        profile2_simState: secondary?.simState || "-",
        profile2_vendor: secondary?.vendor || "-",
        profile2_imsi: secondary?.imsi || "-",

        //Third Profile
         profile3_msisdn: tertiary?.msisdn || "-",
        profile3_simState: tertiary?.simState || "-",
        profile3_vendor: tertiary?.vendor || "-",
        profile3_imsi: tertiary?.imsi || "-",

        // **NEW: Combined SIM state**
        combinedSimState: getCombinedSimState(),

        // Keep original data for card view
        _primaryData: primary,
        _secondaryData: secondary,
        _tertiaryData: tertiary, 

        // Use primary's ICCID as the main identifier if it exists
        iccid: primary?.iccid || secondary?.iccid,
        msisdn: primary?.msisdn || secondary?.msisdn,
      };

      merged.push(mergedItem);
    });

    console.log("Merge Profile Results:", {
      inputCount: dataArray.length,
      outputCount: merged.length,
      relationKeysFound: Object.keys(relationMap).length,
      incompletePairsCount: incompletePairs.length,
      incompletePairs: incompletePairs.slice(0, 5), // Show first 5
    });

    return merged;
  };

  const fetchDeviceDetails = async (iccid) => {
    try {
      const requestBody = {};
      if (iccid) {
        requestBody.iccid = iccid;
        requestBody.accountId = companyId;
      }

      if (data) {
        const simStateMap = {
          "Safe Custody": "SafeCustody",
          "Activation Failed": "ActivationFailed",
          "In Progress": "InProgress",
          "Total SIM": "",
          Activated: "Active",
          Available: "Available",
          Suspended: "SafeCustody",
          Terminated: "Terminated",
        };
        requestBody.simState = simStateMap[data] || "";
        requestBody.accountId = companyId;
      }

      debugger;
if (profileCombo) {
  const vendor1 =
    profileCombo[0] === "Vi" ? "Vodafone" : profileCombo[0];

  const vendor2 =
    profileCombo[1] === "Vi" ? "Vodafone" : profileCombo[1];

  requestBody.vendor = vendor2
    ? `${vendor1} + ${vendor2}`
    : vendor1;

  requestBody.simState = simState || "";
  requestBody.accountId = companyId;
}

   if (profileCombos) {
  const vendors = profileCombos
    .filter(Boolean)
    .map((vendor) => (vendor === "Vi" ? "Vodafone" : vendor));

  requestBody.availableProfiles = vendors.join(" + ");

  requestBody.simState = simState || "";
  requestBody.accountId = companyId;
}
      if (KycStatus) {
        if (KycStatus == "Approved") {
          requestBody.kycStatus = "Compliant";
        } else if (KycStatus == "Pending") {
          requestBody.kycStatus = "Pending";
        } else if (KycStatus == "InProgress") {
          requestBody.kycStatus = "INPROGRESS";
        } else if (KycStatus == "Failed") {
          requestBody.kycStatus = "FAILED";
        }
        requestBody.accountId = companyId;
      }

      if (FilterTitle) {
        requestBody.filterField = FilterTitle;
        requestBody.accountId = companyId;
      }
      if (vendor || month || planId) {
        requestBody.vendor = vendor;
        requestBody.month = month;
        requestBody.planCode = planId;
      }

       handleApplyFilter(requestBody);
    } catch (error) {
      console.error("Failed to fetch device details:", error);
      throw error;
    }
  };

  const handleIccidFilter = async () => {
    if (
      iccid ||
      data ||
      profileCombo ||
      KycStatus ||
      FilterTitle ||
      profileCombos ||
      vendor ||
      month ||
      planId
    ) {
      console.log("Selected ICCID:", iccid);
      
      try {
        setLoading(true);
        const filteredData = await fetchDeviceDetails(iccid);

        let displayData;
        if (iccid) {
          displayData = filteredData.filter((item) => item.iccid === iccid);
          if (displayData?.length === 0) {
            displayData = filteredData;
          }
          setCustomData(filteredData);
        } else {
          displayData = filteredData;
          setCustomData(filteredData);
        }

        // MERGE PROFILES BEFORE SETTING STATE
        const mergedData = mergeProfiles(displayData);

        if (filteredData && filteredData?.length > 0) {
          setOriginalInventoryList(mergedData);
          setDuplicatedata(mergedData);
          setCommonFilteredData(mergedData);
          setTotalRows(mergedData?.length);
          setFilters((prev) => ({
            ...prev,
            pageNo: 0,
            search: "",
          }));

          setGlobalCheckedItems(new Set());

          const searchType = iccid ? `ICCID: ${iccid}` : `criteria: ${data}`;
          setMessage(
            `Found ${mergedData?.length} device(s) matching ${searchType}`,
          );
          setStatusColor("success");
          setAlertOpen(true);
        } else {
          const searchType = iccid ? `ICCID: ${iccid}` : `criteria: ${data}`;
          setMessage(`No devices found for ${searchType}`);
          setStatusColor("error");
          setAlertOpen(true);
          setOriginalInventoryList([]);
          setDuplicatedata([]);
          setCommonFilteredData([]);
          setCustomData([]);
          setTotalRows(0);
        }
        window.history.replaceState({}, document.title);
      } catch (error) {
        console.error("Error filtering data:", error);
        setMessage("Error occurred while filtering data");
        setStatusColor("error");
        setAlertOpen(true);
      } finally {
        // setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (
      iccid ||
      data ||
      profileCombo ||
      KycStatus ||
      FilterTitle ||
      (profileCombos && !vendor && !month) ||
      vendor ||
      month ||
      planId
    ) {
      handleIccidFilter(iccid);
      return;
    } else if (location.state?.fromSearch && location.state.iccid) {
      handleIccidFilter();
    }
  }, [location.state]);

  useEffect(() => {
    const searchTermLower = filters.search?.toLowerCase() || "";
    let allFilteredData = searchTermLower
      ? originalInventoryList.filter((item) =>
          Object.values(item)?.some(
            (val) =>
              typeof val === "string" &&
              val.toLowerCase().includes(searchTermLower),
          ),
        )
      : originalInventoryList;

    allFilteredData = allFilteredData?.map((item) => ({
      ...item,
      checked: globalCheckedItems.has(item.iccid) || false,
    }));

    setDuplicatedata(allFilteredData);
    setCommonFilteredData(allFilteredData);
  }, [
    filters.search,
    filters.pageNo,
    filters.pageSize,
    globalCheckedItems,
    originalInventoryList,
  ]);

  const handleUploadedInventoryData = useCallback(
    (data) => {
      const newItems = data.map((item, index) => {
        const mappedItem = {
          serial: originalInventoryList?.length + index + 1,
          msisdn: item["Primary MSISDN"] || "",
          iccid: item["ICCID"] || "",
          euccid: item["EUICCID"] || "",
          simType: item["Sim Type"] || "",
          profileType: item["Profile type"] || "BootStrap",
          simState: item["Sim State"] || "Active",
          deviceType: item["Device Type"] || "Deice 4G",
          serialNo: item["Serial No"] || "",
          account: item["Customer Name"] || "",
          activationDate: item["Activation Date"] || "",
          deviceId: item["deviceId"] || "",
        };
        return mappedItem;
      });
      setOriginalInventoryList((prevList) => [...prevList, ...newItems]);
      setMessage("Inventory uploaded to table successfully!");
      setStatusColor("success");
      setAlertOpen(true);
    },
    [originalInventoryList?.length],
  );

  // UPDATED: Handle page change with backend API
  const handlePageChange = (_, newPage) => {
    if (isFilterActive) {
      fetchFilteredInventoryData(
        activeFilterPayload,
        newPage,
        filters.pageSize,
      );
    } else if (!isbulk) {
      fetchAndSetInventoryData(companyId, newPage, filters.pageSize);
    }
  };

  // UPDATED: Handle rows per page change with backend API
  const handleRowsPerPageChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    if (isFilterActive) {
      fetchFilteredInventoryData(activeFilterPayload, 0, newSize);
    } else if (!isbulk) {
      fetchAndSetInventoryData(companyId, 0, newSize);
    }
  };

  const rangeFilterFields = [
    { name: "ICCID", value: "iccid", type: "string" },
    { name: "Profile1 MSISDN", value: "profile1_msisdn", type: "string" },
    { name: "Profile2 MSISDN", value: "profile2_msisdn", type: "string" },
    { name: "IMSI", value: "imsi", type: "string" },
  ];

  const [selectedRow, setSelectedRow] = useState(null);
  const [showCard, setShowCard] = useState(false);
  const [customData, setCustomData] = useState([]); //all data

  const fetchPlanDetails = async (planId) => {
    if (!planId) {
      setPlanDetails(null);
      return;
    }

    try {
      setLoadingPlan(true);
      const token = localStorage.getItem("authToken");

      const response = await api.get(`${BASE_URL}apis/plans/${planId}`, {});

      setPlanDetails(response.data);
    } catch (error) {
      console.error("Error fetching plan details:", error);
      setPlanDetails(null);
    } finally {
      setLoadingPlan(false);
    }
  };

  const fetchKYCDetails = async (msisdn) => {
    setLoadingPlan(true);
    try {
      const token = localStorage.getItem("authToken");

      const response = await api.get(
        `${BASE_URL}api/sim-management/kyc/fetch?msisdn=${msisdn}`,
      );

      setKYCDetails(response.data?.data?.simKycList?.[0] || null);
      console.log("KYC Details:", response.data?.data?.simKycList?.[0]);
    } catch (error) {
      console.error("Error fetching KYC details:", error);
      setKYCDetails(null);
    } finally {
      setLoadingPlan(false);
    }
  };

  // UPDATED: Fetch inventory data with backend pagination and merge profiles
  const fetchAndSetInventoryData = async (companyId, page = 0, size = 10) => {
    try {
      setLoading(true);
      // Request double the page size because API returns both primary + secondary
      const apiPageSize = size;
      const result = await fetchInventoryData(companyId, page, apiPageSize);
      console.log("Fetched inventory data:", result);
      console.log("Total Elements from API:", result.pagination.totalElements);
      console.log("Page Number:", result.pagination.pageNumber);
      console.log("Requested Page Size:", apiPageSize);

      // Store raw data for card view
      const rawData = result.data || result.body || [];
      setCustomData(rawData);

      // Merge profiles for table view
      const mergedData = mergeProfiles(rawData);
      console.log("Merged data length:", mergedData.length);

      setDuplicatedata(mergedData);
      setOriginalInventoryList(mergedData);

      // CRITICAL: Divide totalElements by 2 because we merge primary+secondary into 1 row
      const totalElements = result.pagination.totalElements || 0;
      const actualTotalRows = Math.ceil(totalElements );
      console.log("Setting totalRows to:", actualTotalRows, "(API total / 2)");
      setTotalRows(actualTotalRows);

      // Apply checked state
      const dataWithCheckedState = mergedData.map((item) => ({
        ...item,
        checked: globalCheckedItems.has(item.iccid) || false,
      }));

      setCommonFilteredData(dataWithCheckedState);

      setFilters((prev) => ({
        ...prev,
        pageNo:
          result.pagination.pageNumber !== undefined
            ? result.pagination.pageNumber
            : page,
        pageSize: size, // Use the requested merged page size, not API size
      }));

      console.log("Filters updated:", {
        pageNo: result.pageNumber !== undefined ? result.pageNumber : page,
        pageSize: size,
        totalRows: actualTotalRows,
      });
    } catch (err) {
      console.error("Error fetching inventory:", err);
      setMessage("Failed to fetch inventory data");
      setStatusColor("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  function fetchFilterDataWithBulkUpload(filterPayload, commonFilteredData) {
    const filteredDevices = commonFilteredData.filter((item) => {
      return Object.entries(filterPayload).every(([key, value]) => {
        if (value === "" || value === null || value === undefined) return true;
        return String(item[key]).toLowerCase() === String(value).toLowerCase();
      });
    });

    const mergedData = mergeProfiles(filteredDevices);

    setCustomData(filteredDevices);
    setDuplicatedata(mergedData);
    setOriginalInventoryList(mergedData);
    setTotalRows(mergedData.length);
  }

  // UPDATED: Fetch filtered inventory data and merge profiles
  const fetchFilteredInventoryData = async (
    filterPayload,
    page = 0,
    size = 10,
  ) => {
    debugger;
    try {
      setLoading(true);
      const result = await fetchFilteredData(filterPayload, page, size);
      console.log("Filtered data result:", result);

      const rawData = result.data || result.body || [];

      if (!result || rawData.length === 0) {
        setCustomData([]);
        setDuplicatedata([]);
        setOriginalInventoryList([]);
        setTotalRows(0);

        setFilters((prev) => ({
          ...prev,
          pageNo: 0,
          pageSize: size,
        }));
        return;
      }

      // Store raw data for card view
      setCustomData(rawData);

      // Merge profiles for table view
      const mergedData = mergeProfiles(rawData);
      console.log("Filtered merged data length:", mergedData.length);

      setDuplicatedata(mergedData);
      setOriginalInventoryList(mergedData);

      // CRITICAL: Divide totalElements by 2 because we merge primary+secondary into 1 row
      const totalElements = result.pagination.totalElements || 0;
      const actualTotalRows = Math.ceil(totalElements );
      console.log(
        "Setting filtered totalRows to:",
        actualTotalRows,
        "(API total / 2)",
      );
      setTotalRows(actualTotalRows);

      setFilters((prev) => ({
        ...prev,
        pageNo:
          result.pagination.pageNumber !== undefined
            ? result.pagination.pageNumber
            : page,
        pageSize: size || size,
      }));

      const dataWithCheckedState = mergedData.map((item) => ({
        ...item,
        checked: globalCheckedItems.has(item.iccid) || false,
      }));

      setCommonFilteredData(dataWithCheckedState);

      console.log("Filtered pagination:", {
        pageNo:
          result.pagination.pageNumber !== undefined
            ? result.pagination.pageNumber
            : page,
        pageSize: result.pagination.pageSize || size,
        totalRows: actualTotalRows,
        totalPages: Math.ceil(actualTotalRows / size),
      });
    } catch (err) {
      console.error("Error fetching filtered data:", err);
      setMessage("Failed to fetch filtered data");
      setStatusColor("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const showsecondaryProfile = (filterPayload) => {
    fetchFilteredInventoryData(filterPayload, 0, 10);
    setShowCard(false);
  };

  // NEW: Bulk upload and update table with merged profiles
  const handleBulkUploadInventory = async (file, simType) => {
    setIsFilterDataWithBulkUpload(true);
    try {
      setLoading(true);
      setIsbulk(true);
      const result = await bulkUploadInventory(file, simType);
      console.log("Bulk upload result:", result.alert.message);
      if (result.success && result.data) {
        // Store raw data
        setCustomData(result.data);

        // Merge profiles for table view
        const mergedData = mergeProfiles(result.data);

        setDuplicatedata(mergedData);
        setOriginalInventoryList(mergedData);
        setTotalRows(mergedData?.length);
        setFilters((prev) => ({
          ...prev,
          pageNo: 0,
          pageSize: Math.round(mergedData?.length),
          search: "",
        }));

        // Clear checked items
        setGlobalCheckedItems(new Set());
        if (result?.alert?.noDataIccids?.length > 0) {
          alert(
            `These ICCIDs were not uploaded as they do not exist in the system: ${result.alert.noDataIccids.join(
              ", ",
            )}`,
          );
        }
        return result;
      } else {
        throw new Error(result.message || "Upload failed");
      }
    } catch (error) {
      console.error("Error in bulk upload:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    const tempOptions = await getOptions(companyId);
    setOptions(tempOptions);
    console.log("optionsssss", options);
  };

  useEffect(() => {
    fetchData();

    if (
      !iccid &&
      !data &&
      !profileCombo &&
      !KycStatus &&
      !FilterTitle &&
      !profileCombos &&
      !vendor &&
      !month
    ) {
      fetchAndSetInventoryData(companyId, filters.pageNo, filters.pageSize);
    }
  }, [companyId, iccid]);

  useEffect(() => {
    if (selectedRow && selectedRow.planId && generaldata === "Plan Details") {
      fetchPlanDetails(selectedRow.planId);
    } else if (generaldata === "KYC Details") {
      fetchKYCDetails(selectedRow.msisdn);
    } else {
      setPlanDetails(null);
    }
  }, [selectedRow, generaldata]);

  const filterConfiguration = useMemo(() => {
    const unique = (key) => [
      ...new Set(
        options.map((item) => item[key]).filter((v) => v && v.trim() !== ""),
      ),
    ];

    const config = [
      {
        key: "accountName",
        label: "Account",
        type: "select",
        options: unique("accountName"),
      },
      {
        key: "allocatedTo",
        label: "Allocated To",
        type: "select",
        options: unique("allocatedTo"),
      },

      ...(superAdmin
        ? [
            {
              key: "vendor",
              label: "Profile Operator",
              type: "select",
              options: ["Airtel", "Bsnl", "Vodafone"],
            },
          ]
        : []),

      {
        key: "simState",
        label: "Sim State",
        type: "select",
        options: [
          "ACTIVE",
          "Available",
          "Suspended",
          "Terminated",
          "SafeCustody",
          "ActivationFailed",
          "InProgress",
          "Already_Active"
        ],
      },
      {
        key: "simType",
        label: "Sim Type",
        type: "select",
        options: ["eSIM", "Physical"],
      },
      {
        key: "deviceType",
        label: "Device Type",
        type: "select",
        options: unique("deviceType"),
      },
      {
        key: "masterRequestId",
        label: "Request Id",
        type: "autocomplete",
        options: unique("masterRequestId"),
      },
      {
        key: "activationDate",
        label: "Activation Date Range",
        type: "dateRange",
        dateFormat: "DD/MM/YYYY",
      },
      {
        key: "validity",
        label: "Expiry Date Range",
        type: "dateRange",
        dateFormat: "DD/MM/YYYY",
      },
      {
        key: "kycStatus",
        label: "KYC Status",
        type: "select",
        options: ["Compliant", "Pending", "INPROGRESS", "FAILED"],
      },
      {
        key: "kycMasterRequestId",
        label: "KYC Master Request ID",
        type: "autocomplete",
        options: unique("kycMasterRequestId"),
      },
    ];

    return config;
  }, [options, superAdmin]);

  const handleApplyFilter = useCallback(
     (filterPayload) => {
      if (Object.keys(filterPayload)?.length === 0) {
        // Reset filters
        setIsFilterActive(false);
        setActiveFilterPayload({});
         fetchAndSetInventoryData(companyId, 0, 10);
      } else {
        // Apply filters
        if (isFilterDataWithBulkUpload) {
          fetchFilterDataWithBulkUpload(filterPayload, commonFilteredData);
        } else {
          setIsFilterActive(true);
          setActiveFilterPayload(filterPayload);
           fetchFilteredInventoryData(filterPayload, 0, filters.pageSize);
        }
      }
    },
    [
      companyId,
      filters.pageSize,
      isFilterDataWithBulkUpload,
      commonFilteredData,
    ],
  );

  const moduleHeaders = [
    { key: "iccid", label: "ICCID" },
    { key: "imsi", label: "IMSI" },
    { key: "msisdn", label: "MSISDN" },
  ];

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleRangeFilterPreview = useCallback(
    (rangeFilteredData) => {
      const syncedData = rangeFilteredData?.map((item) => ({
        ...item,
        checked: globalCheckedItems.has(item.iccid) || false,
      }));
      const startIndex = filters.pageNo * filters.pageSize;
      const endIndex = startIndex + filters.pageSize;
      const currentPageData = syncedData.slice(startIndex, endIndex);

      setCommonFilteredData(currentPageData);
      setTotalRows(syncedData?.length);
    },
    [globalCheckedItems, filters.pageNo, filters.pageSize],
  );

  const handleApplyRangeAction = useCallback(
    (itemsToModify) => {
      const identifiersToUpdate = new Set(
        itemsToModify?.map((item) => item.iccid),
      );
      const updatedOriginal = originalInventoryList?.map((originalItem) => {
        if (identifiersToUpdate.has(originalItem.iccid)) {
          const modifiedItem = itemsToModify.find(
            (modified) => modified.iccid === originalItem.iccid,
          );
          return { ...modifiedItem };
        }
        return originalItem;
      });

      if (isFilterActive) {
        fetchFilteredInventoryData(
          activeFilterPayload,
          filters.pageNo,
          filters.pageSize,
        );
      } else {
        fetchAndSetInventoryData(companyId, filters.pageNo, filters.pageSize);
      }

      const newGlobalCheckedItems = new Set(globalCheckedItems);
      identifiersToUpdate.forEach((id) => newGlobalCheckedItems.delete(id));
      setGlobalCheckedItems(newGlobalCheckedItems);
    },
    [
      originalInventoryList,
      globalCheckedItems,
      isFilterActive,
      activeFilterPayload,
      filters.pageNo,
      filters.pageSize,
      companyId,
    ],
  );

  // UPDATED: Full table reset
  const handleFullTableReset = useCallback(() => {
    setIsFilterActive(false);
    setIsbulk(false);
    setIsFilterDataWithBulkUpload(false);

    setActiveFilterPayload({});
    setGlobalCheckedItems(new Set());
    document.getElementById("Global-Search").value = "";

    fetchAndSetInventoryData(companyId, 0, 10);
  }, [companyId, filters.pageSize]);

  const handleTableDataUpdate = useCallback(
    (newData) => {
      setCommonFilteredData(newData);

      const newGlobalCheckedItems = new Set(globalCheckedItems);
      newData.forEach((item) => {
        if (item.checked) {
          newGlobalCheckedItems.add(item.iccid);
        } else {
          newGlobalCheckedItems.delete(item.iccid);
        }
      });
      setGlobalCheckedItems(newGlobalCheckedItems);
    },
    [globalCheckedItems],
  );

  const planKeys = [
    "selectedPlan",
    "planName",
    "planData",
    "planSms",
    "planCost",
    "validity",
  ];

  const fetchDataForExport = async () => {
    setLoading(true);
    try {
      const payload = isFilterActive ? activeFilterPayload : {};
      const result = await fetchFilteredData(payload, 0, 0);
      debugger;

      if (result && result.data && result.data.length > 0) {
        const mergedData = mergeProfiles(result.data);
        console.log("Data fetched for export:", mergedData);
        return mergedData;
      }
      return [];
    } catch (error) {
      console.error("Error fetching data for export:", error);
      setMessage("Failed to fetch data for export");
      setStatusColor("error");
      setAlertOpen(true);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const handleButtonAction = async (action) => {
    switch (action) {
      case "uploadInventory":
        setUploadModal(true);
        break;
      case "filter":
        setShowCustomFilterCard(true);
        break;
      case "excel":
        try {
          setLoading(true);
          const payload = isFilterActive ? activeFilterPayload : {};
          await GetExcel(payload);
          setLoading(false);
        } catch (error) {
          console.error("Error exporting to Excel:", error);
          setMessage("Failed to export data to Excel");
          setStatusColor("error");
          setAlertOpen(true);
          setLoading(false);
        }

        break;
      case "pdf":
        const pdfData = await fetchDataForExport();
        if (pdfData.length > 0) {
          generatePDF(pdfData, columns, "filtered_inventory_data.pdf");
        } else {
          setMessage("No data available to export");
          setStatusColor("warning");
          setAlertOpen(true);
        }
        break;
      case "csv":
        const csvExportData = await fetchDataForExport();
        if (csvExportData.length > 0) {
          const data = handleCsvGeneration(csvExportData, columns);
          setCsvData(data);
        } else {
          setMessage("No data available to export");
          setStatusColor("warning");
          setAlertOpen(true);
        }
        break;
      default:
        console.log("Unknown action:", action);
    }
  };

  const [isEditingDeviceId, setIsEditingDeviceId] = useState(false);
  const [editDeviceIdValue, setEditDeviceIdValue] = useState("");
  const [isSavingDeviceId, setIsSavingDeviceId] = useState(false);

  const handleDeviceIdSave = async () => {
    debugger;
    if (!selectedRow || !selectedRow.iccid) {
      setMessage("No ICCID found for this device");
      setStatusColor("error");
      setAlertOpen(true);
      return;
    }
    const trimmed = editDeviceIdValue.trim();
    const isNumber = /^\d+$/.test(trimmed);

    if (!isNumber) {
      setMessage("IMEI number must contain only digits");
      setStatusColor("error");
      setAlertOpen(true);
      return;
    }

    if (trimmed.length < 12 || trimmed.length > 14) {
      alert("IMEI number must be between 12 and 14 digits");
      setMessage("IMEI number must be between 12 and 14 digits");
      setStatusColor("error");
      setAlertOpen(true);
      return;
    }

    const associatedSecondary = selectedRow._secondaryData;

    setIsSavingDeviceId(true);
    try {
      await saveSimState(
        selectedRow.iccid,
        trimmed,
        associatedSecondary ? associatedSecondary.iccid : null,
        associatedSecondary ? associatedSecondary.deviceId : null,
      );

      // Update the selected row with new deviceId
      const updatedRow = { ...selectedRow, deviceId: trimmed };
      setSelectedRow(updatedRow);

      // Update the data in all relevant state arrays
      const updateDeviceId = (dataArray) =>
        dataArray?.map((item) => {
          if (item.iccid === selectedRow.iccid) {
            return { ...item, deviceId: trimmed };
          }
          return item;
        });

      setOriginalInventoryList((prev) => updateDeviceId(prev));
      setDuplicatedata((prev) => updateDeviceId(prev));
      setCommonFilteredData((prev) => updateDeviceId(prev));
      setCustomData((prev) => updateDeviceId(prev));

      setMessage(
        associatedSecondary
          ? "Device ID updated successfully for primary profile (secondary profile maintains its own device ID)"
          : "Device ID updated successfully",
      );
      setStatusColor("success");
      setAlertOpen(true);
      setIsEditingDeviceId(false);

      if (isFilterActive) {
        fetchFilteredInventoryData(
          activeFilterPayload,
          filters.pageNo,
          filters.pageSize,
        );
      } else {
        fetchAndSetInventoryData(companyId, filters.pageNo, filters.pageSize);
      }
    } catch (error) {
      console.error("Error updating device ID:", error);
      setMessage("Failed to update Device ID");
      setStatusColor("error");
      setAlertOpen(true);
    } finally {
      setIsSavingDeviceId(false);
    }
  };

  const renderCard = () => {
    // Function to get display label for field keys
    const getFieldLabel = (key) => {
      const labelMap = {
        deviceId: "Device IMEI",
        msisdn: "MSISDN",
        imsi: "IMSI",
        simType: "SIM Type",
        simState: "SIM State",
        profileType: "Profile Type",
        activationDate: "Activation Date",
        vendor: "Operator",
        whitelisting: "Whitelisting",
      };
      return labelMap[key] || key;
    };

    switch (generaldata) {
      case "General data": {
        const primaryData = selectedRow._primaryData || selectedRow;
        const secondaryData = selectedRow._secondaryData;

        const secondaryFieldsToShow = [
          "iccid",
          "msisdn",
          "imsi",
          "simType",
          "account",
          ...(superAdmin ? ["simState", "activationDate"] : []),
          "profileType",
          "vendor",
          "deviceId",
        ];

        return (
          <div
            style={{
              padding: "24px 32px",
              maxHeight: "500px",
              overflowY: "auto",
              scrollbarWidth: "thin",
              msOverflowStyle: "none",
            }}
          >
            <style>
              {`
                div::-webkit-scrollbar {
                  width: 6px;
                }
                div::-webkit-scrollbar-thumb {
                  background-color: rgba(0,0,0,0.2);
                  border-radius: 4px;
                }
                div::-webkit-scrollbar-thumb:hover {
                  background-color: rgba(0,0,0,0.35);
                }
              `}
            </style>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                gap: "20px",
                marginBottom: secondaryData ? "30px" : "0px",
              }}
            >
              {Object.entries(primaryData)
                .filter(
                  ([key]) =>
                    key !== "checked" &&
                    !planKeys.includes(key) &&
                    key !== "relationKey" &&
                    key !== "id" &&
                    key !== "activationDateTo" &&
                    key !== "activationDateFrom" &&
                    key !== "planId" &&
                    key !== "companyId" &&
                    key !== "euccid" &&
                    key !== "serialNo" &&
                    key !== "_primaryData" &&
                    key !== "_secondaryData" &&
                    !key.startsWith("profile1_") &&
                    !key.startsWith("profile2_"),
                )
                ?.map(([key, value]) => (
                  <div key={key}>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#888",
                        marginBottom: "4px",
                        fontWeight: 500,
                        textTransform: "uppercase",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {getFieldLabel(key)}
                      {key === "deviceId" && (
                        <button
                          onClick={() => {
                            setIsEditingDeviceId(true);
                            setEditDeviceIdValue(value || "");
                          }}
                          style={{
                            background: "none",
                            border: "1px solid #007bff",
                            borderRadius: "4px",
                            color: "#007bff",
                            cursor: "pointer",
                            fontSize: "10px",
                            padding: "2px 6px",
                            textTransform: "uppercase",
                            fontWeight: 600,
                          }}
                          title="Edit Device Number"
                        >
                          Edit
                        </button>
                      )}
                    </div>
                    <div
                      style={{
                        fontSize: "15px",
                        color: "#333",
                        fontWeight: 600,
                        wordWrap: "break-word",
                      }}
                    >
                      {key === "deviceId" && isEditingDeviceId ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <input
                            type="text"
                            value={editDeviceIdValue}
                            onChange={(e) =>
                              setEditDeviceIdValue(e.target.value)
                            }
                            style={{
                              padding: "6px 8px",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              fontSize: "14px",
                              width: "150px",
                            }}
                            placeholder="Enter Device Number"
                            autoFocus
                          />
                          <button
                            onClick={handleDeviceIdSave}
                            disabled={false}
                            style={{
                              backgroundColor: "#28a745",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              padding: "6px 10px",
                              fontSize: "12px",
                              cursor: isSavingDeviceId
                                ? "not-allowed"
                                : "pointer",
                              opacity: isSavingDeviceId ? 0.6 : 1,
                            }}
                          >
                            {isSavingDeviceId ? "Saving..." : "Save"}
                          </button>
                          <button
                            onClick={() => {
                              setIsEditingDeviceId(false);
                              setEditDeviceIdValue("");
                            }}
                            style={{
                              backgroundColor: "#dc3545",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              padding: "6px 10px",
                              fontSize: "12px",
                              cursor: "pointer",
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        value || "-"
                      )}
                    </div>
                  </div>
                ))}
            </div>

            {secondaryData && (
              <div
                style={{
                  background: "#f0f7ff",
                  borderRadius: "16px",
                  boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
                  padding: "24px 28px",
                  border: "1px solid #007bff",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "2px solid #007bff",
                    paddingBottom: "8px",
                    marginBottom: "20px",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#0056b3",
                      margin: 0,
                    }}
                  >
                    Associated Profile Details
                  </h3>

                  <Button
                    startIcon={<OpenInNewIcon />}
                    onClick={() =>
                      showsecondaryProfile({
                        msisdn: secondaryData?.msisdn,
                      })
                    }
                  ></Button>
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(220px, 1fr))",
                    gap: "20px",
                  }}
                >
                  {secondaryFieldsToShow?.map((key) => (
                    <div key={`secondary_${key}`}>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#0056b3",
                          marginBottom: "6px",
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {getFieldLabel(key)}
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#222",
                          fontWeight: 600,
                          wordWrap: "break-word",
                        }}
                      >
                        {secondaryData[key] || "-"}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      }

      case "KYC Details": {
        if (!KYCDetails) {
          return (
            <div
              style={{
                textAlign: "center",
                padding: "40px",
                color: "#666",
                fontSize: "16px",
              }}
            >
              {loadingPlan ? "Loading KYC details..." : "No KYC details found"}
            </div>
          );
        }

        const kycDisplayData = [
          {
            key: "mobileNo",
            label: "Mobile No",
            value: KYCDetails?.mobileNo,
          },
          {
            key: "kycCompletionDate",
            label: "KYC Completion Date",
            value: KYCDetails?.kycCompletionDate
              ? new Date(KYCDetails.kycCompletionDate).toLocaleDateString()
              : "N/A",
          },
          {
            key: "status",
            label: "Status",
            value: KYCDetails?.status,
          },
          {
            key: "simStatus",
            label: "SIM Status",
            value: KYCDetails?.simStatus,
          },
          {
            key: "activationDate",
            label: "Activation Date",
            value: KYCDetails?.activationDate
              ? new Date(KYCDetails.activationDate).toLocaleDateString()
              : "N/A",
          },
          {
            key: "complianceDate",
            label: "Compliance Date",
            value: KYCDetails?.complianceDate
              ? new Date(KYCDetails.complianceDate).toLocaleDateString()
              : "N/A",
          },
          {
            key: "custodianName",
            label: "Custodian Name",
            value: KYCDetails?.custodianName,
          },
          {
            key: "custodianAddress",
            label: "Custodian Address",
            value: KYCDetails?.custodianAddress,
          },
        ];

        return (
          <div style={{ padding: "20px" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                gap: "24px",
                marginBottom: "30px",
              }}
            >
              {kycDisplayData?.map(({ key, label, value }) => (
                <div
                  key={key}
                  style={{
                    padding: "16px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#6c757d",
                      marginBottom: "8px",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {label}
                  </div>
                  <div
                    style={{
                      fontSize: "15px",
                      color: "#212529",
                      fontWeight: 600,
                      wordWrap: "break-word",
                    }}
                  >
                    {value || "-"}
                  </div>
                </div>
              ))}
            </div>

            {KYCDetails?.simNo && (
              <div
                style={{
                  marginTop: "20px",
                  padding: "20px",
                  backgroundColor: "#e3f2fd",
                  borderRadius: "12px",
                  border: "1px solid #2196f3",
                }}
              >
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    marginBottom: "15px",
                    color: "#1976d2",
                  }}
                >
                  SIM Information
                </h4>
                <div style={{ fontSize: "14px", color: "#333" }}>
                  <strong>SIM Number:</strong> {KYCDetails.simNo}
                </div>
                <div style={{ fontSize: "14px", color: "#333" }}>
                  <strong>Failed Reason:</strong> {KYCDetails.errorMessage}
                </div>
                {KYCDetails.euiccId && (
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#333",
                      marginTop: "8px",
                    }}
                  >
                    <strong>EUICCID:</strong> {KYCDetails.euiccId}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      }

      case "Plan Details": {
        if (!selectedRow.planId) {
          return (
            <div
              style={{
                textAlign: "center",
                padding: "40px",
                color: "#666",
                fontSize: "16px",
              }}
            >
              No plan assigned to this SIM
            </div>
          );
        }

        if (loadingPlan) {
          return (
            <div
              style={{
                textAlign: "center",
                padding: "40px",
                fontSize: "16px",
                color: "#666",
              }}
            >
              Loading plan details...
            </div>
          );
        }

        if (!planDetails) {
          return (
            <div
              style={{
                textAlign: "center",
                padding: "40px",
                color: "#d32f2f",
                fontSize: "16px",
              }}
            >
              Failed to load plan details
            </div>
          );
        }

        const planDisplayData = [
          { key: "planName", label: "Plan Name", value: planDetails.planName },
          {
            key: "dataAllowance",
            label: "Data Allowance",
            value: `${planDetails.dataAllowance} `,
          },
          {
            key: "smsAllowance",
            label: "SMS Allowance",
            value: `${planDetails.smsAllowance}`,
          },
          { key: "validity", label: "Validity", value: planDetails.validity },
          {
            key: "amount",
            label: "Amount",
            value: `${planDetails.currency} ${planDetails.amount}`,
          },
        ];

        return (
          <div style={{ padding: "20px" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                gap: "24px",
                marginBottom: "30px",
              }}
            >
              {planDisplayData?.map(({ key, label, value }) => (
                <div
                  key={key}
                  style={{
                    padding: "16px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#6c757d",
                      marginBottom: "8px",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {label}
                  </div>
                  <div
                    style={{
                      fontSize: "15px",
                      color: "#212529",
                      fontWeight: 600,
                      wordWrap: "break-word",
                    }}
                  >
                    {value || "-"}
                  </div>
                </div>
              ))}
            </div>

            {planDetails.oneTimeChargeList &&
              planDetails.oneTimeChargeList.length > 0 && (
                <div
                  style={{
                    marginTop: "20px",
                    padding: "20px",
                    backgroundColor: "#fff3e0",
                    borderRadius: "12px",
                    border: "1px solid #ff9800",
                  }}
                >
                  <h4
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      marginBottom: "15px",
                      color: "#f57c00",
                    }}
                  >
                    One Time Charges
                  </h4>
                  {planDetails.oneTimeChargeList?.map((charge, index) => (
                    <div
                      key={index}
                      style={{
                        padding: "8px 12px",
                        backgroundColor: "rgba(255, 152, 0, 0.1)",
                        borderRadius: "4px",
                        marginBottom: "8px",
                        fontSize: "14px",
                      }}
                    >
                      {charge}
                    </div>
                  ))}
                </div>
              )}
          </div>
        );
      }

      default:
        return null;
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      const isCtrlShiftL =
        event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "l";

      if (isCtrlShiftL) {
        event.preventDefault();
        setQuickIccidModalOpen(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);


  return (
    <>
      <CommonRangeFilter
        open={showCustomFilterCard}
        onClose={() => setShowCustomFilterCard(false)}
        filterConfig={filterConfiguration}
        onApplyFilter={handleApplyFilter}
      />

      {loading && <Spinner />}
      <div className={styles.headingContainer} style={{ display: "flex" }}>
        <Heading
          heading={"Sim Management"}
          data={commonFilteredData}
          showSearch={true}
          arrowRedirection={false}
          showToFromDate={false}
          buttonArray={buttonArray}
          handleButtonAction={handleButtonAction}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          setFilters={setFilters}
          filters={filters}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <RangeActionFilter
          data={duplicatedata}
          onApplyAction={handleApplyRangeAction}
          onFilteredDataChange={handleRangeFilterPreview}
          availableFields={rangeFilterFields}
          availableActions={[
            { name: "Active", value: "Active" },
            { name: "Terminated", value: "Terminated" },
            { name: "Change Device Details", value: "change_device_type" },
            { value: "allocate", name: "Allocate" },
            { value: "SafeCustody", name: "Safe Custody" },
            { name: "Whitelist", value: "whitelist" },
            { name: "KYC", value: "KYC" },
            { name: "Top Up", value: "Top_Up" },
             { value: "Renewal", name: "Renewal" },
          ]}
          actionTargetField="simState"
          dateFormat="DD/MM/YYYY"
          onReset={handleFullTableReset}
        />
      </div>
      <div className={styles.container}>
        <SimManagementTable
          columns={columns}
          showsort={false}
          data={commonFilteredData}
          setData={handleTableDataUpdate}
          tableCss={tableCss}
          totalRows={totalRows}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          handleGetById={() => {}}
          iscard={true}
          filters={filters}
          onRowClick={(row) => {
            setSelectedRow(row);
            setShowCard(true);
          }}
        />
      </div>
      {showCard && selectedRow && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "60%",
            height: "auto",
            backgroundColor: "#fff",
            border: "1px solid #e0e0e0",
            borderRadius: "10px",
            paddingBottom: "24px",
            zIndex: 1300,
            boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
            fontFamily: "Segoe UI, Roboto, sans-serif",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              backgroundColor: "#4151e0",
              padding: "16px 32px 0 32px",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
              color: "#fff",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "8px",
                borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
                marginBottom: "0",
              }}
            >
              {["General data", "KYC Details", "Plan Details"].map((tab) => (
                <div
                  key={tab}
                  onClick={() => handleClick(tab)}
                  style={{
                    padding: "12px 20px",
                    cursor: "pointer",
                    backgroundColor:
                      generaldata === tab ? "#1937cc" : "transparent",
                    color:
                      generaldata === tab ? "#fff" : "rgba(255, 255, 255, 0.7)",
                    fontWeight: 600,
                    fontSize: "16px",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                    boxShadow:
                      generaldata === tab ? "inset 0 -4px 0 0 #4151e0" : "none",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (generaldata !== tab) {
                      e.currentTarget.style.color = "#d0e6fa";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (generaldata !== tab) {
                      e.currentTarget.style.color = "rgba(255, 255, 255, 0.7)";
                    }
                  }}
                >
                  {tab}
                </div>
              ))}
            </div>
          </div>

          <div style={{ flex: 1, padding: "24px 32px", overflowY: "auto" }}>
            {/* {renderCard()} */}
            <DeviceDetailsCardContent
              activeTab={generaldata}
              selectedRow={selectedRow}
              superAdmin={superAdmin}
              planKeys={planKeys}
              isEditingDeviceId={isEditingDeviceId}
              setIsEditingDeviceId={setIsEditingDeviceId}
              editDeviceIdValue={editDeviceIdValue}
              setEditDeviceIdValue={setEditDeviceIdValue}
              isSavingDeviceId={isSavingDeviceId}
              onSaveDeviceId={handleDeviceIdSave}
              onShowSecondaryProfile={showsecondaryProfile}
              KYCDetails={KYCDetails}
              loadingPlan={loadingPlan}
              planDetails={planDetails}
            />
          </div>

          <div style={{ textAlign: "right", padding: "0 32px 16px 32px" }}>
            <button
              onClick={() => setShowCard(false)}
              style={{
                backgroundColor: "#1976d2",
                color: "#fff",
                padding: "10px 20px",
                fontSize: "14px",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <AssignInventoryModal open={assignModal} setOpen={setAssignModal} />
      <UploadExcel
        open={uploadModal}
        setOpen={setUploadModal}
        alertOpen={alertOpen}
        setAlertOpen={setAlertOpen}
        message={message}
        setMessage={setMessage}
        statusColor={statusColor}
        setStatusColor={setStatusColor}
        handleAlertClose={handleAlertClose}
        moduleHeaders={moduleHeaders}
        inventoryValidationRules={inventoryValidationRules}
        setLoading={setLoading}
        moduleName="Upload Inventory"
        fileSample={sampleExcelPath}
        fetchSimInventory={handleBulkUploadInventory}
      />
      <QuickIccidSearchModal
        open={quickIccidModalOpen}
        onClose={() => setQuickIccidModalOpen(false)}
      />
      {csvData && generateCSV(csvData, "inventory_data.csv")}
    </>
  );
};

export default DeviceManagement;
